import Glide from '@glidejs/glide';

class glideLoader {
    
    constructor() {
        this.initSettings();
        document.addEventListener('DOMContentLoaded', () => {
            Array.from(document.querySelectorAll('[data-glide]')).forEach((el) => {
                try {
                    const slider = new Glide(el, this.getTypeSettings(el.dataset.glideType)),
                        slides = Array.from(el.querySelectorAll('.glide__slide'));
                    if(slides.length > 0) {
                        let indexMovingOut;
                        let indexMovingIn;

                        slider.on('run.before', (move) => {
                            indexMovingOut = slider.index;
                        }).on('run', (move) => {
                            indexMovingIn = slider.index;
                            slides[indexMovingOut].classList.add('out');
                            slides[indexMovingIn].classList.add('in');
                        }).on('run.after', (move) => {
                            slides[indexMovingOut].classList.remove('out');
                            slides[indexMovingIn].classList.remove('in');
                        });
                        slider.mount();
                    
                        $('.nav-tabs[data-retain-navigation] a').on('shown.bs.tab', function (e) {
                            slider.update();
                        });
                    }

                    if ((el.dataset.glideType == 'pricing' && slides.length < 3) || (el.dataset.glideType == 'resources' && slides.length < 3)) {
                        el.classList.add('no-nav');
                    }

                } catch (e) { console.error('Error', e); }

            });
        });
    }

    initSettings() {
        
    }

    getTypeSettings(type) {
        const settings = {
            resources: {
                type: 'slider',
                startAt: 0,
                perView: 1,
                gap: 30
            },
            // icons: {
            //     type: 'carousel',
            //     startAt: 0,
            //     perView: 6,
            //     gap: 40,
            //     peek: 0,
            //     breakpoints: {
            //         992: {
            //             perView: 1,
            //         }
            //     }
            // }
        };
        return settings[type];
    }
}
window.app.add('glide', new glideLoader());